import { relationshipLabels, supportGroupRoles } from '@innerhive-internal/innerhive-common';
import { IRelationship, ISupportGroupKey } from './ICareMap';

export type ICommunitySubKey = 'extracurricular' | 'advocacy' | 'general';

type ILookupMap = {[index: string]: string};

interface ISelectOption<T = string> {
    label: string;
    value: T;
}

export class SupportGroupDataProvider {

    getDiagnosisSelectOptions = () => {
        return this.getSelectOptions(this.diagnoses) as ISelectOption[];
    };

    diagnoses: {[diagnosisId: string]: string} = {
        'acquired-immunodeficiency-syndrome': 'Acquired Immunodeficiency Syndrome (AIDS)',
        'alcohol-related-birth-defects': 'Alcohol-Related Birth Defects (ARBD)',
        'alzheimers-disease': 'Alzheimer’s Disease',
        'anemia': 'Anemia',
        'anxiety': 'Anxiety',
        'anxiety-and-depression': 'Anxiety and Depression',
        'anxiety-disorder': 'Anxiety Disorder',
        'arthritis': 'Arthritis',
        'asthma': 'Asthma',
        'attention-deficit-disorder': 'Attention Deficit Disorder',
        'attention-deficit-hyperactivity-disorder': 'Attention Deficit Hyperactivity Disorder (ADHD)',
        'auditory-processing-disorder': 'Auditory Processing Disorder',
        'autism-spectrum-disorder': 'Autism Spectrum Disorder (ASD)',
        'bladder-cancer': 'Bladder Cancer',
        'blindness': 'Blindness',
        'brain-cancer': 'Brain Cancer',
        'breast-cancer': 'Breast Cancer',
        'bronchitis': 'Bronchitis',
        'bronchopulmonary-dysplasia': 'Bronchopulmonary Dysplasia (BPD)',
        'cancer': 'Cancer',
        'celiac-disease': 'Celiac Disease',
        'cerebral-palsy': 'Cerebral Palsy (CP)',
        'chronic-bronchitis': 'Chronic Bronchitis',
        'chronic-fatigue-syndrome': 'Chronic Fatigue Syndrome (CFS)',
        'chronic-heart-failure': 'Chronic Heart Failure',
        'chronic-kidney-disease': 'Chronic Kidney Disease (CKD)',
        'chronic-liver-disease': 'Chronic Liver Disease',
        'chronic-lung-disease': 'Chronic Lung Disease',
        'chronic-lymphocytic-leukemia': 'Chronic Lymphocytic Leukemia (CLL)',
        'chronic-myeloid-leukemia': 'Chronic Myeloid Leukemia (CML)',
        'chronic-obstructive-pulmonary-disease': 'Chronic Obstructive Pulmonary Disease (COPD)',
        'chronic-pain': 'Chronic Pain',
        'chronic-respiratory-disease': 'Chronic Respiratory Disease',
        'colorectal-cancer': 'Colorectal Cancer',
        'conduct-disorder': 'Conduct Disorder (CDD)',
        'congenital-heart-disease': 'Congenital Heart Disease',
        'coronary-artery-disease': 'Coronary Artery Disease (CAD)',
        'coronary-heart-disease': 'Coronary Heart Disease (CHD)',
        'cystic-fibrosis': 'Cystic Fibrosis',
        'deafness': 'Deafness',
        'dementia': 'Dementia',
        'depression': 'Depression',
        'developmental-disabilities': 'Developmental Disabilities',
        'diabetes-type-1': 'Diabetes (Type 1)',
        'diabetes-type-2': 'Diabetes (Type 2)',
        'down-syndrome': 'Down Syndrome',
        'dwarfism': 'Dwarfism',
        'dyscalculia': 'Dyscalculia',
        'dysgraphia': 'Dysgraphia',
        'dyslexia': 'Dyslexia',
        'dyspraxia': 'Dyspraxia',
        'eating-disorder': 'Eating Disorder',
        'eczema': 'Eczema',
        'emphysema': 'Emphysema',
        'epilepsy': 'Epilepsy',
        'executive-function-disorder': 'Executive Function Disorder (EFD)',
        'fetal-alcohol-spectrum-disorder': 'Fetal Alcohol Spectrum Disorder (FASD)',
        'fetal-alcohol-syndrome': 'Fetal Alcohol Syndrome (FAS)',
        'fragile-x-syndrome': 'Fragile X Syndrome (FXS)',
        'gastroesophageal-reflux-disease': 'Gastroesophageal Reflux Disease (GERD)',
        'head-trauma': 'Head Trauma',
        'hearing-impairment': 'Hearing Impairment',
        'hearing-loss': 'Hearing Loss',
        'heart-disease': 'Heart Disease',
        'hemophilia': 'Hemophilia',
        'hodgkin-lymphoma': 'Hodgkin Lymphoma',
        'human-immunodeficiency-virus': 'Human Immunodeficiency Virus (HIV)',
        'hyperlipidemia': 'Hyperlipidemia (High Cholesterol)',
        'hypertension': 'Hypertension (High Blood Pressure)',
        'hypothyroidism': 'Hypothyroidism',
        'inflammatory-bowel-disease': 'Inflammatory Bowel Disease',
        'intellectual-and-developmental-disabilities': 'Intellectual and Developmental Disabilities (IDD)',
        'intellectual-disability': 'Intellectual Disability',
        'learning-disabilities': 'Learning Disabilities',
        'leukemia': 'Leukemia',
        'lung-cancer': 'Lung Cancer',
        'melanoma': 'Melanoma',
        'muscular-dystrophy': 'Muscular Dystrophy',
        'myalgic-encephalomyelitis': 'Myalgic Encephalomyelitis (ME)',
        'non-hodgkin-lymphoma': 'Non-Hodgkin Lymphoma',
        'obesity': 'Obesity',
        'obsessive-compulsive-disorder': 'Obsessive-Compulsive Disorder (OCD)',
        'oppositional-defiant-disorder': 'Oppositional Defiant Disorder (ODD)',
        'osteoporosis': 'Osteoporosis',
        'pancreatic-cancer': 'Pancreatic Cancer',
        'parkinsons-disease': 'Parkinson’s Disease',
        'partial-fetal-alcohol-syndrome': 'Partial Fetal Alcohol Syndrome (pFAS)',
        'polycystic-ovary-syndrome': 'Polycystic Ovary Syndrome (PCOS)',
        'post-traumatic-stress-disorder': 'Post-Traumatic Stress Disorder (PTSD)',
        'prematurity': 'Prematurity',
        'prostate-cancer': 'Prostate Cancer',
        'recurring-bronchitis': 'Recurring Bronchitis',
        'respiratory-syncytial-virus': 'Respiratory Syncytial Virus (RSV)',
        'sensory-processing-disorder': 'Sensory Processing Disorder',
        'severe-combined-immunodeficiency': 'Severe Combined Immunodeficiency (SCID)',
        'shingles': 'Shingles',
        'short-bowel-syndrome': 'Short Bowel Syndrome',
        'sickle-cell-disease': 'Sickle Cell Disease',
        'specific-language-impairment': 'Specific Language Impairment (SLI)',
        'spina-bifida': 'Spina Bifida',
        'spinal-muscular-atrophy': 'Spinal Muscular Atrophy (SMA)',
        'spondyloepiphyseal-dysplasia-congenita': 'Spondyloepiphyseal Dysplasia Congenita (SEDC)',
        'stroke': 'Stroke',
        'tourette-syndrome': 'Tourette Syndrome',
        'vision-and-hearing-impairments': 'Vision and Hearing Impairments',
        'vision-impairment': 'Vision Impairment',
        'vision-loss': 'Vision Loss',
    };

    getAllergySelectOptions = () => {
        return this.getSelectOptions(this.allergies) as ISelectOption[];
    };

    allergies: {[allergyId: string]: string} = {
        'milk': 'Milk',
        'dairy': 'Dairy',
        'eggs': 'Eggs',
        'peanuts': 'Peanuts',
        'tree-nuts': 'Tree Nuts',
        'fish': 'Fish',
        'shellfish': 'Shellfish',
        'wheat': 'Wheat',
        'soy': 'Soy',
        'sesame': 'Sesame',
        'mustard': 'Mustard',
        'celery': 'Celery',
        'lupin': 'Lupin',
        'sulfites': 'Sulfites',
        'kiwi': 'Kiwi',
        'banana': 'Banana',
        'avocado': 'Avocado',
        'corn': 'Corn',
        'buckwheat': 'Buckwheat',
        'garlic': 'Garlic',
        'oats': 'Oats',
        'poultry-meat': 'Poultry Meat',
        'red-meat': 'Red Meat',
        'rice': 'Rice',
        'tartrazine': 'Tartrazine',
        'balsam-of-peru': 'Balsam of Peru',
        'pollen': 'Pollen',
        'cats': 'Cats',
        'dogs': 'Dogs',
        'bees': 'Bees',
        'cockroaches': 'Cockroaches',
        'mold': 'Mold',
        'fragrances': 'Fragrances',
        'cosmetics': 'Cosmetics',
        'dust-mites': 'Dust mites',
        'latex': 'Latex',
        'penicillin': 'Penicillin',
        'local-anesthetics': 'Local Anesthetics',
        'non-steroidal-anti-inflammatories': 'Non-Steroidal Anti-Inflammatories',
        'tetracycline': 'Tetracycline',
        'sulfonamides': 'Sulfonamides',
        'cephalosporins': 'Cephalosporins',
        'phenytoin': 'Phenytoin',
        'carbamazepine': 'Carbamazepine',
        'intravenous-contrast-dye': 'Intravenous Contrast Dye'
    };

    getRelationshipSelectOptions = () => {
        return this.getSelectOptions(this.relationships) as ISelectOption<IRelationship>[];
    };

    // The picker's id for a label it offers; undefined for a label someone typed themselves.
    getRelationshipIdForLabel = (label: string | undefined): IRelationship | undefined => {
        const ids = Object.keys(this.relationships) as IRelationship[]; // Object.keys widens to string
        return ids.find(id => this.relationships[id] === label);
    };

    getSelectOptions = (map: ILookupMap): ISelectOption[] => {
        return Object.keys(map).reduce((acc: any[], curr: string) => {
            acc.push({value: curr, label: map[curr]});
            return acc;
        }, []);
    };

    getSupportGroupMemberSelectOptions = (supportGroupKey: ISupportGroupKey) => {
        if (supportGroupKey === 'school') {
            return this.getSchoolSupportGroupMemberSelectOptions();
        }
        if (supportGroupKey === 'medical') {
            return this.getMedicalSupportGroupMemberSelectOptions();
        }
        if (supportGroupKey === 'specialists') {
            return this.getSpecialistsSupportGroupMemberSelectOptions();
        }
        if (supportGroupKey === 'community') {
            return this.getCommunitySupportGroupMemberSelectOptions();
        }
        if (supportGroupKey === 'financial') {
            return this.getFinancialSupportGroupMemberSelectOptions();
        }
        if (supportGroupKey === 'social') {
            return this.getSocialSupportGroupMemberSelectOptions();
        }
        return [];
    };

    getSchoolSupportGroupMemberSelectOptions = (): ISelectOption[] => {
        return this.getSelectOptions(this.roles['school']);
    };

    getMedicalSupportGroupMemberSelectOptions = (): ISelectOption[] => {
        return this.getSelectOptions(this.roles['medical']);
    };

    getSpecialistsSupportGroupMemberSelectOptions = (): ISelectOption[] => {
        return this.getSelectOptions(this.roles['specialists']);
    };

    getFinancialSupportGroupMemberSelectOptions = (): ISelectOption[] => {
        return this.getSelectOptions(this.roles['financial']);
    };

    getSocialSupportGroupMemberSelectOptions = (): ISelectOption[] => {
        return this.getSelectOptions(this.roles['social']);
    };

    getCommunitySupportGroupMemberSelectOptions = (subKey?: ICommunitySubKey): ISelectOption[] => {
        const roles: ILookupMap = {};
        Object.keys(this.roles['community']).forEach((key) => {
            if (!subKey || key.indexOf('_' + subKey) > -1) {
                roles[key] = this.roles['community'][key];
            }
        });
        return this.getSelectOptions(roles);
    };

    getRolesArray = ({ supportGroupKey, subKey }: {supportGroupKey: ISupportGroupKey; subKey?: ICommunitySubKey }): { roleId: string; label: string; }[] => {
        let roles = this.roles[supportGroupKey];

        if (subKey) {
            roles = {};
            Object.keys(this.roles['community']).forEach((key) => {
                if (key.indexOf('_' + subKey) > -1) {
                    roles[key] = this.roles['community'][key];
                }
            });
        }

        return Object.keys(roles).map(roleId => ({ roleId, label: roles[roleId] }));
    };

    getRoleLabel = ({ supportGroupKey, roleId }: { supportGroupKey: ISupportGroupKey, roleId: string }) => {
        const map = this.roles[supportGroupKey];
        const role = map[roleId];
        if (!role) {
            throw new Error(`${supportGroupKey} roleId "${roleId}" not found`);
        }
        return role;
    };

    relationships: {[relationshipId in IRelationship]: string} = relationshipLabels;

    roles: {
        [key in ISupportGroupKey]: ILookupMap
    } = supportGroupRoles;
}
